import { Instance, types, getEnv, flow } from "mobx-state-tree";

import { apiLastAccessedOrganization } from "../api/ApiLastAccessedOrganizationService";
import { appSessionStorage } from "../storage/SessionStorageService";
import { globalModule } from "../service-provider/GlobalModule";
import { StorageModel } from "../storage/StorageModel";
import { endpoints } from "../api/ApiEndpoints";

export const OrganizationKey = "OrganizationId";

const LastAccessedOrganizationModel = types.model({});

export const LastAccessedOrganizationStorageModel = types
  .compose(LastAccessedOrganizationModel, StorageModel)
  .named("LastAccessedOrganizationStorageModel")
  .actions((self) => {
    return {
      mapResponse(response: any) {
        self.data = response;
        appSessionStorage.setStorageItem(OrganizationKey, self.data.organizationId);
      },
      updateLastAccessedOrganization: flow(function* (orgId: number) {
        yield getEnv(self).api.put(self.endpoint, orgId);
        yield self.load();
      }),
    };
  })
  .views((self) => ({
    get endpoint() {
      return endpoints.get("last_accessed_organization");
    },
  }));

export type LastAccessedOrganizationService = Instance<typeof LastAccessedOrganizationStorageModel>;
export const lastAccessedOrganizationService = LastAccessedOrganizationStorageModel.create(
  {},
  {
    api: apiLastAccessedOrganization,
    appSessionStorage: appSessionStorage,
  }
);

globalModule.lastAccessedOrganizationService = lastAccessedOrganizationService;
